// src/lib/utility/initEnvironment.ts

import { onMount } from "svelte";
import { environment, version } from "$lib/stores/environmentStore";
import { initPosthogAnalytics, initGoogleAnalytics } from "$lib/utility/analytics";
import { initRewardful } from "$lib/utility/rewardful";

export function initEnvironment(data: { environment: string; version: string }, analytics?: boolean) {
  environment.set(data.environment);
  version.set(data.version);

  onMount(() => {
    initRewardful();

    if (analytics !== false) {
      initPosthogAnalytics();
      initGoogleAnalytics();
    }
  });
}
